import { render, staticRenderFns } from "./goodsCommission.vue?vue&type=template&id=3bf30cac&scoped=true"
import script from "./goodsCommission.vue?vue&type=script&lang=js"
export * from "./goodsCommission.vue?vue&type=script&lang=js"
import style0 from "./goodsCommission.vue?vue&type=style&index=0&id=3bf30cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf30cac",
  null
  
)

export default component.exports